import { useMemo } from "react";
import SectionHeading from "@/pages/home/components/SectionHeading";
import { articles, categories } from "@/mocks/content";

interface ArticlesSectionProps {
  activeCategory: string;
  onCategoryChange: (category: string) => void;
}

const categoryStyles: Record<string, string> = {
  恋爱技巧: "bg-primary-100 text-primary-700",
  约会攻略: "bg-accent-100 text-accent-900",
  两性话题: "bg-secondary-100 text-secondary-900",
  情感咨询: "bg-primary-100 text-primary-800",
  爱情故事: "bg-accent-100 text-accent-800",
};

export default function ArticlesSection({ activeCategory, onCategoryChange }: ArticlesSectionProps) {
  const list = useMemo(
    () => (activeCategory === "全部" ? articles : articles.filter((a) => a.category === activeCategory)),
    [activeCategory]
  );

  return (
    <section id="articles" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="mx-auto max-w-6xl px-6 md:px-8">
        <SectionHeading
          eyebrow="情感文章精选"
          title="情感文章精选：慢慢读，慢慢懂"
          desc="从恋爱技巧到爱情故事，这里是我们为你挑出的文章。按分类筛选，挑一篇当下最需要的读起。"
        />

        <div className="mt-8 flex flex-wrap gap-2">
          {categories.map((category) => {
            const isActive = category === activeCategory;
            return (
              <button
                key={category}
                type="button"
                onClick={() => onCategoryChange(category)}
                className={`rounded-full px-4 py-1.5 font-label text-sm whitespace-nowrap transition-colors cursor-pointer ${
                  isActive
                    ? "bg-foreground-900 text-background-50"
                    : "border border-background-300 bg-background-100 text-foreground-700 hover:border-primary-300 hover:text-primary-600"
                }`}
                aria-pressed={isActive}
              >
                {category}
              </button>
            );
          })}
        </div>

        {list.length > 0 ? (
          <div className="mt-8 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-3">
            {list.map((article) => (
              <article
                key={article.title}
                className="flex flex-col rounded-lg border border-background-200 bg-background-100 p-5 transition-colors hover:border-primary-200"
              >
                <span
                  className={`inline-flex w-fit rounded-full px-2.5 py-0.5 font-label text-xs ${
                    categoryStyles[article.category] ?? "bg-background-200 text-foreground-700"
                  }`}
                >
                  {article.category}
                </span>
                <h3 className="mt-3 font-heading text-base font-semibold leading-snug text-foreground-950">
                  {article.title}
                </h3>
                <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{article.summary}</p>
                <div className="mt-4 flex items-center gap-2 border-t border-background-200 pt-3 font-label text-xs text-foreground-500">
                  <i className="ri-time-line"></i>
                  阅读约 {article.read}
                </div>
              </article>
            ))}
          </div>
        ) : (
          <div className="mt-8 rounded-lg border border-dashed border-background-300 bg-background-100 py-14 text-center">
            <i className="ri-file-search-line text-3xl text-foreground-300"></i>
            <p className="mt-3 text-sm text-foreground-500">这个分类暂时还没有文章，换一个分类看看吧。</p>
          </div>
        )}
      </div>
    </section>
  );
}